// What the game remembers while the browser tab stays open.
// Only the saved deck survives a page reload (deckMemory.ts keeps it in the browser).
import type { Deck } from '../shared/deck.ts';
import type { PackRun } from './packOpening.ts';

export const session = {
  playerName: '',
  /** the account you are logged in as (null: a guest, or not chosen yet). Its key signs you in to the game server. */
  account: null as { id: string; name: string; key: string } | null,
  /** playing as a guest ("Player" and numbers): card stats count as usual, account stats never will */
  guest: false,
  /** the deck you play with (set by Save Deck) */
  savedDeck: null as Deck | null,
  savedDeckName: '',
  /** what's currently laid out in the deck builder, saved or not */
  workingDeck: new Map() as Deck,
  workingDeckName: '',
  /** the deck in the builder is being made from packs: which ones are open (null = built by hand) */
  packRun: null as PackRun | null,
  /** the archetypes Random Deck built the deck in the builder around: the Deck Helper keeps aiming for them
   *  (null once the deck is cleared, imported or started from packs) */
  workingDeckAim: null as string[] | null,
};
